module.exports = __webpack_public_path__ + "img/jinpai.758b2453.png";